import { NgxMatColorPickerComponent } from '@angular-material-components/color-picker';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-mat-color-picker-toggle',
    standalone: true,
    imports: [CommonModule, FontAwesomeModule, MatButtonModule, MatFormFieldModule],
    templateUrl: './mat-color-picker-toggle.component.html',
    styleUrls: ['./mat-color-picker-toggle.component.scss'],
})
export class MatColorPickerToggleComponent {
    @Input() for: NgxMatColorPickerComponent;
}
